import React, { createContext, useState, useEffect, useMemo } from "react";
import en from "../content/en.json";
import ru from "../content/ru.json";
import ar from "../content/ar.json";

const content = { en, ru, ar };

export const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem("nsa_lang") || "en";
    });

    const data = useMemo(() => content[language], [language]);

    useEffect(() => {
        localStorage.setItem("nsa_lang", language);
        const dir = data?.meta?.dir || "ltr";
        document.documentElement.setAttribute("dir", dir);
        document.documentElement.setAttribute("lang", language);
    }, [language, data]);

    return (
        <ContentContext.Provider value={{ data, language, setLanguage }}>
            {children}
        </ContentContext.Provider>
    );
};
